import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function TermsOfUsePage() {
  const {
    t
  } = useLanguage();
  return <div className="w-full bg-white min-h-screen pb-32" data-id="element-958">
      <div className="bg-corporate-dark text-white py-20 px-4" data-id="element-959">
        <div className="max-w-4xl mx-auto text-center mt-10" data-id="element-960">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-heading font-bold mb-6 tracking-tight" data-id="element-961">
            {t('footer.terms')}
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="text-lg text-gray-300 max-w-2xl mx-auto font-light" data-id="element-962">
            Condiciones generales que regulan el acceso y uso de este sitio web.
          </motion.p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-963">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-12" data-id="element-964">
          {/* Sección 1 */}
          <section data-id="element-965">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-966">
              1. Uso del Sitio Web
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-967">
              <p data-id="element-968">
                El acceso y uso de este sitio web implica la aceptación plena y
                sin reservas de las presentes Condiciones de Uso. Si el usuario
                no está de acuerdo con alguna de estas condiciones, deberá
                abstenerse de utilizar el sitio web.
              </p>
              <p data-id="element-969">
                El usuario se compromete a utilizar este sitio web de forma
                diligente, correcta y lícita, conforme a la legislación vigente,
                la moral, las buenas costumbres y el orden público. En
                particular, el usuario se obliga a:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-970">
                <li data-id="element-971">
                  No utilizar el sitio web con fines ilícitos, fraudulentos o
                  que puedan causar daños a SmartImport Internacional o a
                  terceros.
                </li>
                <li data-id="element-972">
                  No introducir o difundir virus informáticos o cualesquiera
                  otros sistemas que puedan causar daños al sitio web.
                </li>
                <li data-id="element-973">
                  No intentar acceder, utilizar o manipular los datos de
                  SmartImport Internacional, de terceros proveedores o de otros
                  usuarios.
                </li>
                <li data-id="element-974">
                  No reproducir, copiar, distribuir o poner a disposición de
                  terceros los contenidos del sitio web sin autorización
                  expresa.
                </li>
              </ul>
            </div>
          </section>

          {/* Sección 2 */}
          <section data-id="element-975">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-976">
              2. Propiedad del Contenido
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-977">
              <p data-id="element-978">
                Todo el contenido de este sitio web, incluyendo textos,
                imágenes, fotografías de productos, catálogos, fichas técnicas,
                documentos descargables, logotipos, diseño gráfico, código
                fuente y cualquier otro material, es propiedad exclusiva de
                SmartImport Internacional o de sus legítimos licenciantes y está
                protegido por las leyes de propiedad intelectual e industrial
                aplicables.
              </p>
              <p data-id="element-979">
                El acceso al sitio web no otorga al usuario ningún derecho de
                propiedad sobre los contenidos. Queda prohibida cualquier forma
                de reproducción, distribución, comunicación pública,
                transformación o cualquier otra actividad que se pueda realizar
                con los contenidos sin la autorización previa y por escrito de
                SmartImport Internacional.
              </p>
              <p data-id="element-980">
                Los catálogos y fichas técnicas disponibles para descarga están
                destinados exclusivamente a uso profesional por parte de
                distribuidores, arquitectos y profesionales del sector. Su
                redistribución comercial sin autorización está expresamente
                prohibida.
              </p>
            </div>
          </section>

          {/* Sección 3 */}
          <section data-id="element-981">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-982">
              3. Limitación de Responsabilidad
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-983">
              <p data-id="element-984">
                SmartImport Internacional no garantiza la disponibilidad
                permanente ni la continuidad del funcionamiento del sitio web, y
                no será responsable de:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-985">
                <li data-id="element-986">
                  Interrupciones en el servicio, retrasos, errores o mal
                  funcionamiento del sitio web.
                </li>
                <li data-id="element-987">
                  Daños o perjuicios de cualquier tipo derivados del acceso o
                  uso del sitio web.
                </li>
                <li data-id="element-988">
                  Inexactitudes o errores en la información publicada,
                  incluyendo especificaciones técnicas de productos que pueden
                  variar sin previo aviso.
                </li>
                <li data-id="element-989">
                  Daños causados por virus o elementos tecnológicos lesivos que
                  pudieran afectar al equipo del usuario.
                </li>
                <li data-id="element-990">
                  Contenidos o servicios de sitios web de terceros a los que se
                  pueda acceder mediante enlaces desde este sitio web.
                </li>
              </ul>
              <p data-id="element-991">
                La información sobre productos y materiales se proporciona con
                carácter orientativo. SmartImport Internacional recomienda
                contactar directamente para confirmar disponibilidad,
                especificaciones y precios antes de realizar cualquier pedido.
              </p>
            </div>
          </section>

          {/* Sección 4 */}
          <section data-id="element-992">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-993">
              4. Enlaces a Sitios de Terceros
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-994">
              <p data-id="element-995">
                Este sitio web puede contener enlaces o referencias a sitios web
                de terceros, incluyendo plataformas de descarga de documentos y
                redes sociales. Estos enlaces se proporcionan únicamente para la
                conveniencia del usuario.
              </p>
              <p data-id="element-996">
                SmartImport Internacional no controla ni se hace responsable del
                contenido, las políticas de privacidad o las prácticas de dichos
                sitios web de terceros. El acceso a estos sitios se realiza bajo
                la exclusiva responsabilidad del usuario.
              </p>
            </div>
          </section>

          {/* Sección 5 */}
          <section data-id="element-997">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-998">
              5. Modificaciones
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-999">
              <p data-id="element-1000">
                SmartImport Internacional se reserva el derecho de modificar, en
                cualquier momento y sin previo aviso, la presentación,
                configuración y contenidos del sitio web, así como las presentes
                Condiciones de Uso. Las modificaciones entrarán en vigor desde
                el momento de su publicación en el sitio web.
              </p>
              <p data-id="element-1001">
                El uso continuado del sitio web tras la publicación de cualquier
                modificación constituirá la aceptación de dichos cambios por
                parte del usuario.
              </p>
            </div>
          </section>

          {/* Sección 6 */}
          <section data-id="element-1002">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-1003">
              6. Legislación Aplicable y Jurisdicción
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-1004">
              <p data-id="element-1005">
                Las presentes Condiciones de Uso se rigen por la legislación
                vigente. Para la resolución de cualquier controversia que
                pudiera derivarse del acceso o uso de este sitio web,
                SmartImport Internacional y el usuario acuerdan someterse a los
                Juzgados y Tribunales competentes del domicilio de SmartImport
                Internacional.
              </p>
            </div>
          </section>

          {/* Sección 7 */}
          <section data-id="element-1006">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-1007">
              7. Contacto
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-1008">
              <p data-id="element-1009">
                Para cualquier consulta relacionada con estas Condiciones de Uso
                o con el funcionamiento del sitio web, el usuario puede
                contactar con SmartImport Internacional a través del correo
                electrónico{' '}
                <strong className="text-corporate-dark font-medium" data-id="element-1010">
                  info@smartimport.com
                </strong>
                .
              </p>
            </div>
          </section>

          <div className="border-t border-gray-200 pt-8 mt-12" data-id="element-1011">
            <p className="text-sm text-gray-400 font-light" data-id="element-1012">
              Última actualización: Marzo 2026
            </p>
          </div>
        </motion.div>
      </div>
    </div>;
}